// 权限列表，通过有意义的字符串名称来供全局读取
export const permissionList = {
  // 根权限
  POWERPRO_ROOT: 'pe:powerpro:root',

  // 首页指标查看权限
  HOME_ROOT: 'powerpro:home:root',

  // 查看设备列表
  POWERPRO_EQUIPMENT_ROOT: 'powerpro:equipment:root',
  // 设备管理 - 换电站列表
  POWERPRO_EQUIPMENT_PS: 'equipment:list:view',
  // 设备管理 - 充电桩 & 充电桩群列表
  POWERPRO_EQUIPMENT_PC: 'equipment:powercharger:list',
  // 设备管理 - 智能电表
  POWERPRO_EQUIPMENT_EMETER: 'powerpro:emeter:view',

  // 通用设备管理 - white label 版本 root 权限
  POWERPRO_EQUIPMENT_WHITELABEL_ROOT: 'powerpro:equipmentWhitelabel:root',

  // 显示当前所处环境提示
  POWERPRO_SHOW_ENV_HINT: 'pe:powerpro:showEnvHint',
}
